import _isEqual from 'lodash/isEqual';

import { SelectOption } from '../components/atoms/Select';
import * as Api from '../weborder/Api';
import { BLANK } from '../weborder/constants/Constants';
import USStateList from './data/usStates.json';

export const checkCountryCode = (
  appConfigData: Api.AppConfig,
  requiredCountry: string,
): boolean => {
  const { CountryCode } = appConfigData;
  const isRequiredCountry = CountryCode === requiredCountry;
  return isRequiredCountry;
};

const isFullStreetAddressFirst = (addressLayout) =>
  addressLayout === Api.AddressLayoutType.FullStreetAddressFirst;

const getIsCanadaAddress = (appData: Api.AppConfig): boolean => {
  const { PostCodeInputLabel, DeliveryAddressLayout } = appData;

  const isPostcode = PostCodeInputLabel === 'Post Code';
  return isPostcode && isFullStreetAddressFirst(DeliveryAddressLayout);
};

const getIsUSAddress = (appData: Api.AppConfig): boolean => {
  const { PostCodeInputLabel, DeliveryAddressLayout } = appData;

  const isZip = PostCodeInputLabel === 'Zip';
  return isZip && isFullStreetAddressFirst(DeliveryAddressLayout);
};

const getUSStateCodeList = (): string[] =>
  USStateList.map((state) => state.value);

const getStateShortName = (
  addressComponents: google.maps.GeocoderAddressComponent[],
): string => {
  const detail = addressComponents.find((component) =>
    _isEqual(component.types, ['administrative_area_level_1', 'political']),
  );
  return detail && detail.short_name;
};

const getUSStateOptions = (
  isUsAddress: boolean,
  translate: (key: string) => string,
): SelectOption[] => {
  const stateOptions = [];

  if (!isUsAddress) {
    return stateOptions;
  }

  stateOptions.push({
    disabled: true,
    label: translate('State'),
    key: BLANK,
  });

  USStateList.forEach((state) =>
    stateOptions.push({
      disabled: false,
      label: state.value,
      key: state.value,
    }),
  );

  return stateOptions;
};

export const locationUtils = {
  checkCountryCode,
  getIsCanadaAddress,
  getIsUSAddress,
  getStateShortName,
  getUSStateCodeList,
  getUSStateOptions,
  isFullStreetAddressFirst,
};
